import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  DocumentManagementDashboardComponent
} from './pages/document-management-dashboard/document-management-dashboard.component';
import {
  DocumentManagementDettaglioComponent
} from './pages/document-management-dettaglio/document-management-dettaglio.component';
import {NomiDescrittoriSezione} from "../common/configuration/nomi-descrittori-sezione";
import {authGuardGestioneDocumenti} from "../guards/auth.guard-gestione-documenti";

const routes: Routes = [
  {
    path: '',
    data: { descrittore: NomiDescrittoriSezione.DESCRITTORE_GESTIONE_DOCUMENTI },
    canActivate: [authGuardGestioneDocumenti],
    canActivateChild: [authGuardGestioneDocumenti],
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: DocumentManagementDashboardComponent,
      },
      {
        path: 'dettaglio/:id',
        data:{ title: "Gestione documenti - dettaglio"},
        component: DocumentManagementDettaglioComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DocumentManagementRoutingModule {
}
